<div class="container" id="main-content" aria-label="Main Content">

    <div>
        <h1 tabindex="0" class="heading-title">{{'SUMMARY.TITLE' | translate}}</h1>
        <hr />
    </div>

    <div class="row">
        <div class="col-md-8">
            <div class="card">
                <div class="card-body">
                    <div class="form-row">
                        <div *ngIf="globals.blLanguage == 0" tabindex="0" (click)="linkClicked($event)"
                            (keypress)="linkClicked($event)" [innerHTML]="checklistText | noSanitise">
                        </div>
                        <div *ngIf="globals.blLanguage == 1" tabindex="0" (click)="linkClicked($event)"
                            (keypress)="linkClicked($event)" [innerHTML]="checklistTextIrish | noSanitise">
                        </div>
                    </div>

                    <div class="form-row" #error>
                        <form [formGroup]="checklistForm">
                            <label><input type="checkbox" formControlName="checklistCB"
                                    class="mr-2" tabindex="0">{{'SUMMARY.CHECKLIST_CONFIRM' | translate}}</label>
                            <div *ngIf="submitted && form.checklistCB.errors">
                                <div style="color: red; padding-top: 0.2rem" *ngIf="form.checklistCB.errors.required" role="alert" tabindex="0">
                                    {{'SUMMARY.CHECKLIST_VALIDATION' | translate}}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-4">
            <mat-card>
                <app-booking-summary-card></app-booking-summary-card>
            </mat-card>
        </div>

    </div>

    <div class="row">
        <br />
    </div>

    <div class="row">
        <div class="col-6">
            <button class="btn btn-primary" (click)="routerGoBack()">{{'COMMON.BACK' | translate}}</button>
        </div>
        <div class="col-6 text-right">
            <button class="btn btn-primary" (click)="proceed()">{{'COMMON.PROCEED' | translate}}</button>
        </div>
    </div>
</div>